import CRUDReducer, { CRUDSaveFailAction, ReduceAction } from './CRUDReducer';
import eventCRUDActions from '../actions/event';
import Event from '../api/event';

class ProcessVotingReduceAction extends ReduceAction {
  run() {
    return {
      processingModel: true
    };
  }
}

class UpdateBingoReduceAction extends ReduceAction {
  run(data, currentState = {}) {
    let {voting, votingType} = data;
    let {model} = currentState;



    model[Event.getEventAttr(votingType)] = voting;

    return {
      processingModel: false,
      model
    };
  }
}

class EventCrudReducer extends CRUDReducer {

  /**
   *
   * @param EventCRUDActions actionManager
   * @returns {{}}
   */
  getReducers(actionManager) {
    let reducers = super.getReducers(actionManager);

    reducers[actionManager.saveVotingAction] = new ProcessVotingReduceAction();
    reducers[actionManager.saveVotingSuccessAction] = new UpdateBingoReduceAction();
    reducers[actionManager.saveVotingFailedAction] = new CRUDSaveFailAction();

    reducers[actionManager.publishVotingAction] = new ProcessVotingReduceAction();
    reducers[actionManager.publishVotingSuccessAction] = new UpdateBingoReduceAction();
    reducers[actionManager.publishVotingFailAction] = new CRUDSaveFailAction();

    reducers[actionManager.announceResultVotingAction] = new ProcessVotingReduceAction();
    reducers[actionManager.announceResultVotingSuccessAction] = new UpdateBingoReduceAction();
    reducers[actionManager.announceResultVotingFailAction] = new CRUDSaveFailAction();

    return reducers;
  }
}

const eventCRUDReducer = new EventCrudReducer(eventCRUDActions);

export default (state, action) => eventCRUDReducer.run(state, action);




// WEBPACK FOOTER //
// ./src/reducers/event.js